import Default from "./CopyToClipboardButton";
export * from "./CopyToClipboardButton";
export default Default;
